import { useEffect, useState } from 'react'
import * as React from 'react'
import { HashClaim, getENSFromAddress } from '../../api'
import ClaimFooterMessage from './ClaimFooterMessage'
import { Link } from 'react-router-dom'
import { getDateString, calculateDaysAgo } from '../../lib/helpers/dateHelper'
import { Loading } from '../../components/Loading'

const ClaimAlreadyMinted: React.FC<{ claim: HashClaim }> = ({ claim }) => {
  const collectionAddress = claim?.beneficiary ? claim.beneficiary : claim.user_input

  const appLink = claim.beneficiary ? `/scan/${claim.beneficiary}` : `/scan/${claim.user_input}`
  const claimedDate = new Date(claim.claimed_date)
  const daysAgo = calculateDaysAgo(claimedDate)
  const formatedClaimedDate = getDateString(claimedDate)
  const [ens, setEns] = useState<string | null>(null)

  const poapGalleryUrl = (id: number) => {
    return `https://poap.gallery/event/${id}`
  }

  useEffect(() => {
    getEnsAddress(collectionAddress).then()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getEnsAddress = async (address: string | null) => {
    try {
      if (address) {
        const ensFromAddress = await getENSFromAddress(address)
        setEns(ensFromAddress.valid ? ensFromAddress.ens : address)
      }
    } catch (e) {
      setEns(address)
      console.log(e)
    }
  }

  return (
    <div className={'claim-info'} data-aos="fade-up" data-aos-delay="300">
      <div className={'info-title'}>
        This POAP was added to collection:
        <br />
        {ens && (
          <Link className="collection-link" to={appLink}>
            {ens}
          </Link>
        )}
        {!ens && <Loading />}
      </div>
      <div>
        {
          <span>
            This POAP was minted {daysAgo} days ago on {formatedClaimedDate}
            <br />
            See who else shared this moment at <a href={poapGalleryUrl(claim.event_id)}>POAP Gallery</a>.
          </span>
        }
        <br />
      </div>
      <ClaimFooterMessage />
    </div>
  )
}

export default ClaimAlreadyMinted
